"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mesureDict = void 0;
const mmp = (data) => {
    let mmp = 0;
    const n = data.length;
    for (let i = n; i > 0; i--) {
        mmp += i * data[i - 1];
    }
    mmp = (2 / (n * (n + 1))) * mmp;
    return mmp;
};
const flatScore = (data) => { return data.at(-1); };
exports.mesureDict = { 'mmp': mmp, 'score': flatScore };
